import { dataReportSearch } from 'dls-icons-data'
import { createIcon } from '../common'

const IconReportSearch = /*#__PURE__*/createIcon(dataReportSearch)
export default IconReportSearch
